import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { CheckCircle2, Circle, Clock, Pencil, Trash2, DollarSign } from "lucide-react";
import { cn } from "@/lib/utils";

const statusConfig = {
  not_started: { icon: Circle, color: "text-slate-400", bg: "bg-slate-100 text-slate-700", label: "Ikke Startet" },
  in_progress: { icon: Clock, color: "text-blue-500", bg: "bg-blue-100 text-blue-700", label: "Pågår" },
  completed: { icon: CheckCircle2, color: "text-emerald-500", bg: "bg-emerald-100 text-emerald-700", label: "Fullført" },
};

export default function PhaseCard({ phase, progress, taskCount, estimatedCost, onEdit, onDelete }) {
  const StatusIcon = statusConfig[phase.status]?.icon || Circle;

  return (
    <Card className="bg-white border-l-4 border-l-zinc-900">
      <div className="p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-start gap-3 flex-1">
            <StatusIcon className={cn("w-5 h-5 mt-0.5", statusConfig[phase.status]?.color)} />
            <div className="flex-1">
              <h4 className="font-semibold text-slate-900 mb-1">{phase.name}</h4>
              <Badge className={cn("text-xs border-0", statusConfig[phase.status]?.bg)}>
                {statusConfig[phase.status]?.label}
              </Badge>
            </div>
          </div>
          <div className="flex gap-1">
            <Button variant="ghost" size="icon" className="h-8 w-8" onClick={onEdit}>
              <Pencil className="w-3.5 h-3.5 text-slate-400" />
            </Button>
            <Button variant="ghost" size="icon" className="h-8 w-8" onClick={onDelete}>
              <Trash2 className="w-3.5 h-3.5 text-slate-400 hover:text-rose-600" />
            </Button>
          </div>
        </div>

        {phase.description && (
          <p className="text-sm text-slate-600 mb-3">{phase.description}</p>
        )}

        <div className="space-y-2">
          <div className="flex items-center justify-between text-xs text-slate-500">
            <span>{taskCount} oppgaver</span>
            <span className="font-medium">{Math.round(progress)}%</span>
          </div>
          <Progress value={progress} className="h-1.5" />
          {estimatedCost > 0 && (
            <div className="flex items-center gap-1 text-xs text-emerald-700 bg-emerald-50 px-2 py-1 rounded-md">
              <DollarSign className="w-3 h-3" />
              <span>Estimert kostnad: {estimatedCost.toLocaleString()} kr</span>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}